import type { ApiEndpoint } from "../types";
import { findEndpointByKey } from "./relationshipUtils";

/**
 * Maps a relationship category (a `byTableSlug` key, or an enriched row's `category`)
 * to the configured endpoint `tableName`. Matches DataItemDetails / drawer relationship UIs.
 */
export function mapRelationshipCategoryToTableName(category: string, apiEndpoints: ApiEndpoint[]): string {
  const categoryPart = category.split("/").pop() || category;

  // Prioritize direct match using unified helper
  const slugMatch = findEndpointByKey(apiEndpoints, categoryPart);
  if (slugMatch) return slugMatch.tableName;


  const reverseRelEndpoint = apiEndpoints.find((endpoint) =>
    endpoint.reverseRelationships?.some((rel) => rel.relationshipKey === categoryPart)
  );

  if (reverseRelEndpoint?.reverseRelationships) {
    const reverseRel = reverseRelEndpoint.reverseRelationships.find((rel) => rel.relationshipKey === categoryPart);
    if (reverseRel) {
      const sourceEndpoint = apiEndpoints.find((endpoint) => endpoint.formId === reverseRel.sourceFormId);
      if (sourceEndpoint) {
        return sourceEndpoint.tableName;
      }
    }
  }

  const fallbackEndpoint = apiEndpoints.find(
    (endpoint) => endpoint.tableName === categoryPart || endpoint.tableName.toLowerCase() === categoryPart.toLowerCase()
  );
  if (fallbackEndpoint) {
    return fallbackEndpoint.tableName;
  }

  console.warn("[mapRelationshipCategoryToTableName] No endpoint found for category:", categoryPart);
  return categoryPart;
}
